import TextInput from "Components/molecule/inputs/text-input"
import SearchSelect from "Components/molecule/inputs/search-select"
import { SelectOption } from "Components/molecule/inputs/select-input"
import PrimaryButton from "Components/atoms/buttons/primary-button"
import SecondaryButton from "Components/atoms/buttons/secondary-button"
import FormContainer from "Components/atoms/containers/form-container"
import FormProps from "data/forms"
import DepartmentMappingFields from "./types"

interface DepartmentMappingFormProps extends FormProps<DepartmentMappingFields> {
    sourceTypes: SelectOption[]
}

const ID_KEY = "id";
const SOURCE_TYPE_KEY = "sourceTypeId";

const DepartmentMappingForm = ({
    values,
    handleChange,
    handleBlur,
    handleSubmit,
    handleCancel,
    errors,
    isValid,
    touched,
    isSubmitting,
    sourceTypes,
    edit
}: DepartmentMappingFormProps) => {

    return <FormContainer
        inputs={<>
            <TextInput
                className="col-auto"
                touched={!!touched.id}
                name={ID_KEY}
                key={ID_KEY}
                label={"External Code*"}
                placeholder={"e.g. FINAN00000"}
                value={values.id}
                onBlur={handleBlur}
                onChange={handleChange}
                error={!!touched.id && !!errors.id}
                message={touched.id ? errors.id : undefined}
            />

            {
                !edit &&
                <SearchSelect
                    className="col-auto"
                    name={SOURCE_TYPE_KEY}
                    key={SOURCE_TYPE_KEY}
                    label={"Source System*"}
                    placeholder={"Select a source system"}
                    value={values.sourceTypeId}
                    error={!!touched.sourceTypeId && !!errors.sourceTypeId}
                    message={touched.sourceTypeId ? errors.sourceTypeId : undefined}
                    options={sourceTypes}
                    onChange={(option: SelectOption | null) => handleChange(SOURCE_TYPE_KEY)(option ? option.value : '')}
                    onBlur={handleBlur(SOURCE_TYPE_KEY)}
                />
            }
        </>}
        buttons={<>
            <PrimaryButton
                type='submit'
                onClick={() => handleSubmit()}
                disabled={isSubmitting || !isValid}
            >
                {isSubmitting ? "Saving...." : edit ? "Update" : "Add Mapping"}
            </PrimaryButton>
            {
                handleCancel &&
                <SecondaryButton
                    disabled={isSubmitting}
                    onClick={() => handleCancel()}
                >
                    Cancel
                </SecondaryButton>
            }
        </>}
    />
}

export default DepartmentMappingForm
